import React from 'react';
import { Select } from 'antd';

export const PitstopSelect = ({
  allowClear,
  options = [],
  selectOptionDisplayField = 'name',
  selectOptionValueField = 'id',
  value,
  onChange,
  ...props
}) => {
  const objectOptions = typeof options[0] === 'object';

  const filterOption = (input, option) => {
    return option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  // Transform options to Ant Design v5 format
  const transformedOptions = objectOptions
    ? options.map((option) => ({
        label: option[selectOptionDisplayField],
        value: option[selectOptionValueField],
      }))
    : options.map((option) => ({
        label: option,
        value: option,
      }));

  return (
    <Select
      allowClear={allowClear}
      filterOption={!objectOptions ? true : filterOption}
      showSearch
      style={{ width: 150 }}
      value={value}
      onChange={onChange}
      options={transformedOptions}
      {...props}
    />
  );
};
